export default [
  {
    path: 'M515.4 67.87c-13.38 0-26.76 0.45-40.14 1.78v215.42a17.89 17.89 0 0 0 17.84 17.84h44.6a17.89 17.89 0 0 0 17.84-17.84V69.65c-13.38-1.34-26.76-1.78-40.14-1.78zM542.61 360H605a17.89 17.89 0 0 0 17.84-17.84V112.47h44.6v365.72A20.46 20.46 0 0 1 647 498.7H545.73c-19.62 0-20.52 10.26-20.52 10.26V377.39c-0.44-9.39 7.58-17.39 17.4-17.39z',
    fill: '#008566',
  },
  {
    path: 'M489.09 360h-62.44a17.89 17.89 0 0 1-17.84-17.84V112.47h-44.6v365.72a20.46 20.46 0 0 0 20.52 20.52H486c19.62 0 20.52 10.26 20.52 10.26V377.39c0.41-9.39-7.62-17.39-17.43-17.39zM382 656.14h71.36A17.89 17.89 0 0 1 471.25 674v277h35.68V538a20.46 20.46 0 0 0-20.52-20.52H385.17c-19.62 0-20.52-10.26-20.52-10.26v131.53c-0.45 9.37 7.58 17.39 17.39 17.39z m267.6 0h-71.31A17.89 17.89 0 0 0 560.45 674v277h-35.68V538a20.46 20.46 0 0 1 20.52-20.52h101.23c19.62 0 20.52-10.26 20.52-10.26v131.53c0.45 9.37-7.58 17.39-17.39 17.39z',
    fill: '#008566',
  },
  {
    path: 'M622.89 80.8v92.77c144.5 45.49 249.31 180.63 249.31 340.3 0 197.13-159.67 356.8-356.8 356.8S158.6 711 158.6 513.87c0-160.11 105.26-295.25 250.21-340.74V80.36C213.9 128.52 69.4 304.25 69.4 513.87c0 246.19 199.81 446 446 446s446-199.81 446-446C961.4 304.69 817.34 129 622.89 80.8z',
    fill: '#008566',
  },
  {
    path: 'M537.25 897.43h-44.6a17.89 17.89 0 0 1-17.84-17.84v-223h80.28v223a17.89 17.89 0 0 1-17.84 17.84z',
    fill: '#008566',
  },
]
